import { FavoriteAction, FavoriteArticleState, FavoritesSliceState } from "./types";

export const updateFavoriteReducer = (state: FavoritesSliceState, action: FavoriteAction): FavoritesSliceState => {
  const { contentId, contentType, isFavorite } = action.payload;

  switch (contentType) {
    case 'article':
    default:
      if (!state.articles[contentId]) {
        state.articles[contentId] = {} as FavoriteArticleState;
      }

      state.articles[contentId].id = contentId;
      state.articles[contentId].isFavorite = isFavorite;
      break;
  }

  return state;
};
